import { render, staticRenderFns } from "./forStudy.vue?vue&type=template&id=7492ff28&scoped=true"
import script from "./forStudy.vue?vue&type=script&lang=js"
export * from "./forStudy.vue?vue&type=script&lang=js"
import style0 from "./forStudy.vue?vue&type=style&index=0&id=7492ff28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7492ff28",
  null
  
)

export default component.exports